import React, { Component } from "react";
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { compose } from "redux";
import dotenv from 'dotenv';
import Helper from "../LocServices/Helper"
import { login } from "../../actions/auth";
import { reqLocId_findInfo, 
  reset_LocIdInfo,
  update_loc_simpleFinderMode,
  update_test,
  reqLocId_edit,
  reqLocId_delete,
  update_loc_id,
  update_loc_alert,
  update_loc_loading,
  activateLocToaster,
  getThumbnails
} from "../../reducers/location";

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import "./simple_finder.scss";
import SimpleFinderContent from "./SimpleFinderContent"
import SimpleFinderEdit from "./SimpleFinderEdit"
import SimpleFinderAlert from "./SimpleFinderAlert"
import ImagesUploader from "../ImagesUploader/ImagesUploader"
import ImageThumbnailDisplay from "../ImagesUploader/ImageThumbnailDisplay"


const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

dotenv.config();

class PageSimpleFinder extends Component {
  constructor(props) {
    super(props);
    this.handlelocationId = this.handlelocationId.bind(this);
    this.onChangelocationId= this.onChangelocationId.bind(this);

    this.state = {
      //locationId: 0,
      isValidate: false,
      loading: false,
    };
  }

  componentWillUnmount(){
    //console.log('Good Bye!')
    this.props.reset_LocIdInfo()
  }
  
  componentDidMount(){
    const loc_id = this.props.match.params?.loc_id
    let getRequest = true
    if (loc_id === "0") getRequest = false
    if (typeof(loc_id )== 'undefined') getRequest = false

    if (getRequest) {
      //console.log(`Log id: ${loc_id}`)
      this.props.reqLocId_findInfo(loc_id, this.props.user.chat_id, this.props.user.accessToken)
    }
  }

  onChangelocationId(e) {
    this.props.update_loc_id(e.target.value)
/*     this.setState({
      locationId: e.target.value,
    }); */
  }

  handlelocationId(e) {
    e.preventDefault();
    
    this.setState({
      loading: true,
    });

    this.form.validateAll();

    const { dispatch, history } = this.props;

    //this.props.update_loc_simpleFinderMode("show");

    if (this.checkBtn.context._errors.length === 0) {
      console.log('No Error')
      this.setState({
        loading: false,
        isValidate: true,
      });

      
      this.props.reqLocId_findInfo(this.props.location.location_id, this.props.user.chat_id, this.props.user.accessToken)
      //this.props.test(this.state.locationId, this.props.user.chat_id, this.props.user.accessToken)

    } else {
      console.log('Error!')
      //console.log(this.checkBtn.context._errors) //example ['6fa24203-2a88-4099-af2b-f375e957e496']
      this.setState({
        loading: false,
        isValidate: false,
      });
    }

  }

  render() {
    //----START Auth Lost Test ------
    if (!this.props.user){
      window.location.href = "https://lc.tg41.uk/login";
      return null; // Return null to avoid rendering anything else
    } 
    //----END Auth Lost Test ------

    const { user: currentUser} = this.props;

    if (!currentUser) {
      return <Redirect to="/login" />;
    }

    if (this.props.location.req_result === "Request failed with status code 401") {
      //console.log("fix1")
      this.props.logOut()
    }

    return (
      <div className="col-md-12">
      <div className="card card-container">
{/*         <img
          src="//ssl.gstatic.com/accounts/ui/avatar_2x.png"
          alt="profile-img"
          className="profile-img-card"
        /> */}

        <Form
          onSubmit={this.handlelocationId}
          ref={(c) => {
            this.form = c;
          }}
        >
          <div className="form-group">
            <label htmlFor="username">Locator ID</label>
            <Input
              type="number"
              className="form-control"
              name="locationId"
              value={this.props.location.location_id}
              onChange={this.onChangelocationId}
              validations={[required]}
            />
          </div>

          <div className="form-group">
            <button
              className="btn btn-primary btn-block"
              disabled={this.props.location.isLoading}
            >
{/*               {this.state.loading && (
                <span className="spinner-border spinner-border-sm"></span>
              )} */}
              {this.props.location.isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              <span>Find</span>
            </button>
          </div>

          <CheckButton
            style={{ display: "none" }}
            ref={(c) => {
              this.checkBtn = c;
            }}
          />
        </Form>
      </div>


      <SimpleFinderContent 
        data={this.props.location.location_id_resData}
        isLoading={this.props.location.isLoading}
        update_loc_simpleFinderMode={this.props.update_loc_simpleFinderMode}
        reqLocId_delete={this.props.reqLocId_delete}
        mode={this.props.location.location_simpleFinderMode}
        token={this.props.user.accessToken}

      
      />



      {/* Get data at the first */}
      {(this.props.location.location_id_resData.length !== 0 && this.props.location.location_simpleFinderMode === "edit" ) 
      && <SimpleFinderEdit
        isLoading={this.props.location.isLoading}
        reqLocId_edit={this.props.reqLocId_edit} //thunk redux service
        formData={{
          locationId: this.props.location.location_id,//this.state.locationId,
          chat_id: this.props.user.chat_id,
          accessToken: this.props.user.accessToken,
          ...this.props.location.location_id_resData[0]
          //data: this.props.location.location_id_resData[0]
        }}
        update_loc_simpleFinderMode={this.props.update_loc_simpleFinderMode}

      />}

      <SimpleFinderAlert 
        locAlert={this.props.location.locAlert}
        update_loc_alert={this.props.update_loc_alert}
      />

      <ImagesUploader  
        api_web_address={process.env.REACT_APP_API_IMAGE_WEB}
        location_id_resData = {this.props.location.location_id_resData}
        update_loc_loading={this.props.update_loc_loading}
        isLoading={this.props.location.isLoading}
        activateLocToaster={this.props.activateLocToaster}
        toaster={this.props.location.toaster}
        getThumbnails={this.props.getThumbnails}
      />

      <ImageThumbnailDisplay
        locatorId={this.props.location.location_id}
        api_web_address={process.env.REACT_APP_API_IMAGE_WEB}
        update_loc_loading={this.props.update_loc_loading}
        isLoading={this.props.location.isLoading}
        getThumbnails={this.props.getThumbnails}
        reqThumbnails={this.props.location.reqThumbnails}
      />


      
{/*       <button
      onClick={()=> {
        this.props.update_loc_alert(
          {
            "type": "alert-success",
            "text": "All is OK",
            "time": 2000
          }
        )
      }}
      >
        Click me
      </button> */}
      
      {/* <Helper props={this.state} /> */}  
      <Helper props={this.props} />
      
    </div>
    );
  }
}

function mapStateToProps(state) {
  //console.log(state)
  const { user, test } = state.auth;

  return {
    user,
    test,
    location: state.location
  };
}

  const mapDispatchToProps = { 
    reqLocId_findInfo,
    reset_LocIdInfo,
    update_loc_simpleFinderMode,
    update_test,
    reqLocId_edit,
    reqLocId_delete,
    update_loc_id,
    update_loc_alert,
    update_loc_loading,
    activateLocToaster,
    getThumbnails
  }



export default compose(
  connect(mapStateToProps, mapDispatchToProps)
  //withAuthRedirect
)(PageSimpleFinder);

//connect(mapStateToProps, mapDispatchToProps)(PageSimpleFinder);
